module.exports = __webpack_public_path__ + "static/media/clem-onojeghuo-4.08e9a812.jpg";